import React, { useCallback, useState, useEffect } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import config from "../config";
import axios from "axios";
import Loader from "../components/Loader";
import placeimage from "../image/noimage.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function TrainerList() {
  const navigate = useNavigate();
  const [trainerList, setTrainerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [skillList, setSkillList] = useState([]);
  const params = useParams();
  const location = useLocation();

  const fetchTrainerList = useCallback(async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(location.search);
      const skill = queryParams.get("skill");

      let url = `${config.apiUrl}/trainer?city=${params.city || ''}`;
      if (skill) {
        url += `&skill=${encodeURIComponent(skill)}`;
      }

      const response = await axios.get(url);
      setTrainerList(response.data.data || []);
    } catch (error) {
      return navigate("/error");
    } finally {
      setLoading(false);
    }
  }, [navigate, params.city, location.search]);

  const fetchSkill = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/trainer-skill`);
      setSkillList(response.data.list);
    } catch (error) {
      return navigate("/error");
    }
  }, [navigate]);

  useEffect(() => {
    fetchTrainerList();
    fetchSkill();
  }, [fetchTrainerList, fetchSkill]);

  const imageOnError = (event) => {
    event.currentTarget.src = placeimage;
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Gym & Fitness Trainers In {params.city}</title>
          <meta
            name="description"
            content={`Find top rated & popular gym trainers & fitness trainer in ${params.city} to help you stay fit and healthy.`}
          />
        </Helmet>
      </HelmetProvider>
      <section className="trainer_section">
        <div className="container">
          <h2 className="offHead blog-head">Gym & fitness trainers in {params.city}</h2>
          <span className="text-secondary">
            {" "}
            Showing {trainerList.length} fitness trainers in {params.city}
          </span>
          <div className="row g-3 mt-1">
            <div className="col-lg-3">
              <section className="filter-section">
                <div className="card gym-list-card border-0">
                  <div className="card-body py-2">
                    <h6 className="offHead text-dark pb-2 border-bottom">
                      Filter
                    </h6>

                    <button
                      className="btn btn-light w-100 text-start mt-2"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseCity"
                      aria-expanded="false"
                      aria-controls="collapseCity"
                    >
                      Skills<i className="bi bi-chevron-down loc-down"></i>
                    </button>

                    <div
                      className="collapsible-table collapse show"
                      id="collapseCity"
                    >
                      <table className="table m-0">
                        <tbody>
                          {skillList.map((skill, index) => (
                            <tr key={index}>
                              <td>
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value={skill.slug}
                                    id={skill.slug}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={skill.slug}
                                  >
                                    {skill.name}
                                  </label>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <button className="btn btn-danger mt-3 w-100">Apply</button>
                  </div>
                </div>
              </section>
            </div>
            <div className="col-lg-9">
              {loading ? (
                <Loader />
              ) : (
                trainerList.map((trainer, index) => (
                  <Link
                    to={`/gym-fitness-trainer/varanasi/${trainer.slug}`}
                    className="trainer"
                    key={index}
                  >
                    <div className="card mt-3">
                      <div className="card-body">
                        <div className="row g-2">
                          <div className="col-lg-3">
                            <div className="text-center">
                              <img
                                src={trainer.photo}
                                onError={imageOnError}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                          </div>
                          <div className="col-lg-9">
                            <div className="profile">
                              <h6 className="name">
                                {trainer.name}{" "}
                                <span className="desig">
                                  ({trainer.experience} Yrs Exp.)
                                </span>
                              </h6>
                              <div className="rating">
                                <i className="fas fa-star filled"></i>
                                <i className="fas fa-star filled"></i>
                                <i className="fas fa-star filled"></i>
                                <i className="fas fa-star filled"></i>
                                <i className="fas fa-star filled"></i>
                                <span className="ms-1">(17)</span>
                              </div>
                              <ul className="skill">
                                {trainer.skills.map((skill, index) => (
                                  <li key={index}>{skill.name}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
